// src/pages/Home.js
import React from 'react';
import { Helmet } from 'react-helmet';

// Import des sections
import Hero from '../components/sections/Hero';
import AboutSection from '../components/sections/AboutSection';
import ServicesSection from '../components/sections/ServicesSection';
import ProjectsSection from '../components/sections/ProjectsSection';
import BlogSection from '../components/sections/BlogSection';

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Decko | Créateur de vos parquets de jardin</title>
                <meta name="description" content="Decko vous propose des terrasses en bois sur mesure, des parquets de jardin et des aménagements extérieurs de qualité depuis 1985." />
            </Helmet>

            <Hero />
            <AboutSection />
            <ServicesSection />
            <ProjectsSection />
            <BlogSection />
        </>
    );
};

export default Home;